import styled from 'styled-components';

export const Root = styled.div`
  float: right;
  margin-left: 16px;

  @media (max-width: 920px) {
    clear: both;
    margin-left: 0;
    width: 100%;
  }
`;

export const ButtonArea = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 16px;
  row-gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 920px) {
    justify-content: center;
  }
`;
